export default __webpack_public_path__ + "static/media/optionalActivity.8e973f73.gif";